import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import IncentiveTable from "./Incentive/incentive_table";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import { useSelector } from "react-redux";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { extractDate } from "../../Components/Functions/date.fun";
import { FcBullish } from "react-icons/fc";
import IncentiveUserRevenueChart from "./Incentive/step_incentive_graph";
import { useNavigate, useLocation } from "react-router-dom";

const IncentiveManagement = () => {
  const user = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadname: "",
    leadowner: "",
    status: "",
  });
  const [leadowner, setLeadOwner] = useState([]);
  const [totalIncetiveData, setTotalIncetiveData] = useState([]);
  const [incentiveGraphData, setIncentiveGraphData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page")) || 1;
    setPage(pageFromUrl);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate({ search: params.toString() }, { replace: true });
  }, [page]);

  useEffect(() => {
    performRequest("GET", "/leads/getSalesEmployeeList/")
      .then((res) => {
        setLeadOwner(res.data);
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const getAllIncentive = (startdate = "", enddate = "") => {
    performRequest("GET", "/incentive/getAllIncentive/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.incentive) {
            if (startdate && enddate) {
              let newData = res?.data?.incentive.filter((el) => {
                let date = extractDate(el.createdAt);
                return date >= startdate && date <= enddate;
              });
              setTotalIncetiveData(newData);
            } else {
              setTotalIncetiveData(res.data.incentive);
            }
          }
        } else {
          Toast("error", "Error while getting incentive!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAllIncentive();
  }, []);

  useEffect(() => {
    if (appliedFilters.startdate && appliedFilters.enddate) {
      getAllIncentive(appliedFilters.startdate, appliedFilters.enddate);
    } else {
      getAllIncentive();
    }
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/incentive/getIncentive/", page, appliedFilters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.incentiveCount / 50));
        } else {
          Toast("error", "Error while getting revenue!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [page, refresh, appliedFilters]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/incentive/getIncentiveGraphData/", "", appliedFilters)
    )
      .then((res) => {
        if (res.status === 200) {
          // console.log("Incentive", filters, appliedFilters);
          setIncentiveGraphData(res.data.userRevenueData);
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, [appliedFilters, refresh]);

  const getTotalIncentive = (leadowner) => {
    let amt = 0;
    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.revenueApproved !== "Denied"
        ) {
          amt += +item?.preGstAmount * 0.0025;
        }
      });
    }
    return Math.round(amt);
  };

  const getAprovedIncentive = (leadowner) => {
    let amt = 0;

    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.revenueApproved === "Approved"
        ) {
          amt += +item?.preGstAmount * 0.0025;
        }
      });
    }

    return Math.round(amt);
  };

  const getPendingIncentive = (leadowner) => {
    let amt = 0;

    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.revenueApproved === "Pending"
        ) {
          amt += +item?.preGstAmount * 0.0025;
        }
      });
    }

    return Math.round(amt);
  };

  const getDenideIncentive = (leadowner) => {
    let amt = 0;

    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.revenueApproved === "Denied"
        ) {
          amt += +item?.preGstAmount * 0.0025;
        }
      });
    }

    return Math.round(amt);
  };

  const getTotalRevenue = (leadowner) => {
    let amt = 0;

    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.revenueApproved !== "Denied"
        ) {
          amt += +item?.preGstAmount;
        }
      });
    }

    return Math.round(amt);
  };

  const getWithoutConIncentive = (leadowner) => {
    let amt = 0;

    if (totalIncetiveData) {
      totalIncetiveData.forEach((item) => {
        if (
          item.generatedBy === leadowner &&
          item.sellsType !== "construction payment" &&
          item.sellsType !== "project conversion" &&
          item.revenueApproved !== "Denied"
        ) {
          amt += +item?.preGstAmount;
        }
      });
    }

    return Math.round(amt);
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcBullish className="fs-2  me-1" />
                    Revenue Management
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block ">
                    <ButtonWithSVG
                      href={"/revenue-management/new"}
                      buttonText="Add Sell"
                      svg={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            {/* /////// */}

            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12">
                  <div className="card pt-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name:"
                                  value={filters.leadname}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      leadname: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search sell owner:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      leadowner: e.target.value,
                                    })
                                  }
                                  value={filters.leadowner}
                                >
                                  <option value="">select all</option>
                                  {leadowner &&
                                    leadowner?.map((lead, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={lead?.userName}
                                        >
                                          {lead?.userName}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      status: e.target.value,
                                    })
                                  }
                                  value={filters.status}
                                >
                                  <option value="">select all</option>
                                  <option value="Approved">Approved</option>
                                  <option value="Pending">Pending</option>
                                  <option value="Denied">Denied</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setAppliedFilters(filters);
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        const resetFilters = {
                                          startdate: "",
                                          enddate: "",
                                          leadname: "",
                                          leadowner: "",
                                          status: "",
                                        };

                                        setFilters(resetFilters);
                                        setAppliedFilters(resetFilters);
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name:"
                                value={filters.leadname}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    leadname: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search sell owner:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    leadowner: e.target.value,
                                  })
                                }
                                value={filters.leadowner}
                              >
                                <option value="">select all</option>
                                {leadowner &&
                                  leadowner?.map((lead, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={lead?.userName}
                                      >
                                        {lead?.userName}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Status:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    status: e.target.value,
                                  })
                                }
                                value={filters.status}
                              >
                                <option value="">select all</option>
                                <option value="Approved">Approved</option>
                                <option value="Pending">Pending</option>
                                <option value="Denied">Denied</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setAppliedFilters(filters);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      const resetFilters = {
                                        startdate: "",
                                        enddate: "",
                                        leadname: "",
                                        leadowner: "",
                                        status: "",
                                      };

                                      setFilters(resetFilters);
                                      setAppliedFilters(resetFilters);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9 col-sm-12">
                  {incentiveGraphData.length > 0 && (
                    <IncentiveUserRevenueChart data={incentiveGraphData} />
                  )}
                  {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    user.Role === process.env.REACT_APP_ROLE_ADMIN ||
                    user.Role === process.env.REACT_APP_ROLE_ACCOUNTS) && (
                    <div className="card my-3">
                      <div className="table-responsive">
                        <table className="table table-vcenter">
                          <tbody>
                            <tr>
                              {leadowner?.map((item, index) => {
                                return (
                                  <td key={index}>
                                    <div
                                      style={{ width: "250px" }}
                                      className="card p-2"
                                    >
                                      <td>
                                        Name :{" "}
                                        <span className="strong">
                                          {item?.userName || "N/A"}
                                        </span>
                                      </td>
                                      <td className="fs-2">Incentives :</td>
                                      <td>
                                        Total :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹ {getTotalIncentive(item?.userName)}
                                        </span>
                                      </td>

                                      <td>
                                        Pending :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹{" "}
                                          {getPendingIncentive(item?.userName)}
                                        </span>
                                      </td>
                                      <td>
                                        Approved :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹{" "}
                                          {getAprovedIncentive(item?.userName)}
                                        </span>
                                      </td>

                                      <td>
                                        Denied :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹ {getDenideIncentive(item?.userName)}
                                        </span>
                                      </td>
                                      <td>
                                        New Revenue :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹{" "}
                                          {getWithoutConIncentive(
                                            item?.userName
                                          )}
                                        </span>
                                      </td>

                                      <td>
                                        Total Revenue :{" "}
                                        <span className="strong">
                                          {" "}
                                          ₹ {getTotalRevenue(item?.userName)}
                                        </span>
                                      </td>
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  <div className="card">
                    {data && data?.incentive && (
                      <IncentiveTable
                        incentives={data?.incentive}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    )}
                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/revenue-management/new"}
                          buttonText="Add Sell"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.incentive?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default IncentiveManagement;
